import { ApiClientHr } from 'app/service/api-service'
import { UnitGroupEndPoint } from './constant'

export const requestGetUnitGroupAllManagement = () =>
  ApiClientHr.Get({
    url: `${UnitGroupEndPoint.UnitGroupManagement.request}/get-all`,
    params: {},
  })
